import { render, staticRenderFns } from "./AstaSblocco.vue?vue&type=template&id=b0ac768c&"
import script from "./AstaSblocco.vue?vue&type=script&lang=js&"
export * from "./AstaSblocco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0ac768c')) {
      api.createRecord('b0ac768c', component.options)
    } else {
      api.reload('b0ac768c', component.options)
    }
    module.hot.accept("./AstaSblocco.vue?vue&type=template&id=b0ac768c&", function () {
      api.rerender('b0ac768c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/AstaSblocco.vue"
export default component.exports